// ** Dropdowns Imports
import UserDropdown from './UserDropdown'
import NotificationDropdown from './NotificationDropdown'

// ** Third Party Components
import {Sun, Moon} from 'react-feather'
import {NavItem, NavLink} from 'reactstrap'
import Select from "react-select";
import {selectThemeColors} from "../../../../utility/Utils";
import {
    disciplineAtletikaM, disciplineAtletikaZ,
    disciplinePlivanje
} from "../../../../views/natjecanja/DetaljiNatjecanja/DetaljiNatjecanjaStep2";
import React, {Fragment, useEffect, useState} from "react";
import {getUserData} from "../../../../auth/utils";
import axios from "axios";
import {
    getCurrentOrganisationName,
    getCurrentOrganisationObject,
    getTeamAdminSastavnicaId, isAdmin
} from "../../../../utility/UserUtility";

const NavbarUser = props => {
    let user = getUserData() ? getUserData().userData : null;
    const [constituentOptions, setConstituentOptions] = useState([]);
    const [organisationsOptions, setOrganisationsOptions] = useState([]);
    const [currentConstituent, setCurrentConstituent] = useState(null);
    const [currentOrganisation, setCurrentOrganisation] = useState(null);
    const [dataFetched, setDataFetched] = useState(false);
    useEffect(() => {
            if (getUserData() == null || getUserData().email == null) {
                return;
            }
            if (!dataFetched) {
                setDataFetched(true)
                let user = getUserData() ? getUserData().userData : null;
                if (user) {
                    let orgOptions = user.rights.map((oneRight) => {
                        return {
                            value: oneRight,
                            label: oneRight ? oneRight.name : oneRight
                        }
                    })
                    setOrganisationsOptions(orgOptions)
                    let orgFromStorage = getCurrentOrganisationObject();
                    if (orgFromStorage) {
                        setCurrentOrganisation({
                            value: orgFromStorage,
                            label: orgFromStorage.name
                        });
                    }
                }
                let constituents = user.teamAdminConstituents ? user.teamAdminConstituents : [];
                if (user && user.role && user.role.includes("team leader") && user.teamLeaderConstituents && user.teamLeaderConstituents.length > 0) {
                    constituents = constituents.concat(user.teamLeaderConstituents);
                }
                if (user && user.role && (user.role.includes("team admin") || user.role.includes("team leader")) && constituents && constituents.length > 0) {
                    let url = `${process.env.REACT_APP_MAIN_URL}/admin/constituents`;
                    let organisation = getCurrentOrganisationName();
                    url += `?org=${organisation}&withoutTeams=true`
                    let myConstituents = [];
                    let constituentIdFromStorage = getTeamAdminSastavnicaId();
                    let constituentFromStorage = null
                    axios.get(url).then((result) => {
                        result.data.constituents.map((sastavnica) => {
                            if (constituents.includes(sastavnica._id) || sastavnica._id === user.constituent) {
                                myConstituents.push({
                                    label: sastavnica.name,
                                    value: sastavnica
                                });
                            }
                            if (constituentIdFromStorage === sastavnica._id) {
                                constituentFromStorage = sastavnica
                            }
                        });
                        setConstituentOptions(myConstituents)
                        if (constituentFromStorage) {
                            let myLabel = constituentFromStorage.name;
                            if (user.rights && user.rights.map) {
                                let rightSet = false;
                                user.rights.map((oneRight) => {
                                    if (oneRight && oneRight.id === constituentFromStorage.organisation && !rightSet) {
                                        rightSet = true;
                                        myLabel = myLabel + "-" + oneRight.name;
                                    }
                                })
                            }
                            setCurrentConstituent({
                                value: constituentFromStorage,
                                label: myLabel
                            });
                        } else if (!isAdmin() && myConstituents && myConstituents.length === 1) {
                            setTimeout(() => {
                                window.localStorage.setItem("teamAdminSastavnica", JSON.stringify({
                                    userId: user._id,
                                    constituentId: myConstituents[0].value._id
                                }))
                                window.location.reload();
                            },500)
                        }
                    })
                }
            }
        }
    )
    if (!user) {
        return null;
    }
    let constituents = user.teamAdminConstituents;
    if (user && user.role && user.role.includes("team leader")) {
        constituents = user.teamLeaderConstituents;
    }
    return (
        <ul className='nav navbar-nav align-items-center ml-auto'>
            {user && user.role && (user.role.includes("team admin") || user.role.includes("team leader") || user.role.includes("operative") || user.role.includes("delegate")) && constituents && constituents.length > 0 &&
            <div style={{minWidth: "300px", marginRight: "25px"}}>
                <Select
                    theme={selectThemeColors}
                    className='react-select'
                    classNamePrefix='select'
                    value={currentConstituent}
                    placeholder={"Odaberi sastavnicu"}
                    onChange={(data) => {
                        window.localStorage.setItem("teamAdminSastavnica", JSON.stringify({
                            userId: user._id,
                            constituentId: data.value._id
                        }))
                        window.location.reload();
                    }}
                    name='clear'
                    options={constituentOptions}
                    isClearable={false}
                />
            </div>
            }
            {user && user.role && (user.role.includes("admin") || user.role.includes("team admin") || user.role.includes("team leader") || user.role.includes("operative") || user.role.includes("delegate") || user.role.includes("recreations admin")) && user.rights && user.rights.length > 1 &&
            <div style={{minWidth: "290px", marginRight: "25px"}}>
                <Select
                    theme={selectThemeColors}
                    className='react-select'
                    classNamePrefix='select'
                    value={currentOrganisation}
                    placeholder={"Odaberi organizaciju"}
                    onChange={(data) => {
                        window.localStorage.setItem("organizacija", JSON.stringify({
                            userId: user._id,
                            organisation: data.value
                        }))
                        window.location.reload();
                    }}
                    name='clear'
                    options={organisationsOptions}
                    isClearable={false}
                />
            </div>
            }
            <NotificationDropdown/>
            <UserDropdown/>
        </ul>
    )
}
export default NavbarUser
